var map = {
	"./music_imagery_mtrf_0_100_0_0.5_1_10music_imagery_mtrf_0_100_0_0.5_1_10.png": 7912,
	"./music_imagery_mtrf_0_100_0_0.5_1_10music_imagery_trf_0_100_0_0.5_1_10.png": 9889,
	"./music_imagery_trf_0.001_10_0_0.5_1_10music_imagery_trf_0.01_1000_0_0.5_1_10.png": 6371,
	"./music_imagery_trf_0_1000_-0.3_0.8_1_10music_imagery_trf_0.001_100_-0.5_1_2_19.png": 9435,
	"./music_imagery_trf_0_1000_0_0.5_1_13music_imagery_trf_0.001_100_-0.5_1_2_19.png": 8410,
	"./music_imagery_trf_0_100_-0.2_0.8_1_15music_imagery_trf_0_100_-0.2_0.8_1_8.png": 2884,
	"./music_imagery_trf_0_100_-0.3_0.8_1_15music_imagery_trf_0_100_-0.3_0.8_1_10.png": 4096,
	"./music_imagery_trf_0_100_-0.3_0.8_1_15music_imagery_trf_0_100_-0.3_0.8_1_8.png": 990,
	"./music_imagery_trf_0_100_-0.5_1_1_10music_imagery_trf_0.001_100_-0.2_0.8_2_10.png": 6211,
	"./music_imagery_trf_0_100_-0.5_1_1_13music_imagery_trf_0_100_-0.5_1_1_20.png": 491,
	"./music_imagery_trf_0_100_-0.5_1_1_19music_imagery_trf_0_100_-0.5_1_1_12.png": 7270,
	"./music_imagery_trf_0_100_0_0.5_1_10music_imagery_trf_0_100_0_0.5_1_10.png": 4820,
	"./music_imagery_trf_0_100_0_0.5_1_10speech_listening_trf_0_100_0_0.5_1_10.png": 9793,
	"./music_imagery_trf_0_100_0_0.5_1_14music_imagery_trf_0_100_-0.2_0.7_1_8.png": 4397,
	"./music_imagery_trf_0_100_0_0.5_1_7music_imagery_trf_0_100_-0.2_0.7_1_14.png": 5182,
	"./music_imagery_trf_0_100_0_0.8_1_10music_imagery_trf_0_100_-0.3_0.5_1_17.png": 8591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8825;